<!--Modal-->

<div class="col-md-12">
  <div class="container-btn-new">
      <button class="btn btn-primary" (click)="openDialogAdd()">
    <i class="fa fa-truck"></i>&nbsp; Add Car
  </button>



  </div>

  <br>
  <br>

  <div class="row">
    <div class="col-md-4">

      <mat-form-field class="example-full-width">
        <mat-label>Select Driver</mat-label>

        <mat-select  [formControl]="drivers" (selectionChange)="selectDriver($event)">

          <mat-option value="">Seleccionar</mat-option>
          <mat-option  *ngFor="let dri of driversList" [value]="dri.id">{{ dri.firstname }} {{ dri.lastname}} </mat-option>


        </mat-select>


        <mat-error *ngIf="drivers.hasError('required')">You must make a selection</mat-error>

      </mat-form-field>




    </div>
    <div class="col-md-4">

      <button [disabled]="drivers.hasError('required') || selection.selected.length == 0" class="btn btn-primary btn-md" style="margin-top: 3px" (click)="asignVehicleUser()"> Assign Vehicle &nbsp; <i class="fa fa-edit"></i></button>


      </div>

      <div class="col-md-4">

        <mat-form-field>
          <mat-label>Filter</mat-label>
          <input matInput (keyup)="applyFilter($event)" placeholder="Filter">
      </mat-form-field>

      </div>
  </div>


  <br>



  <div class="mat-elevation-z8">

      <table mat-table [dataSource]="dataSource" matSort (matSortChange)="sortData($event)">


              <!-- Checkbox Column -->
              <ng-container matColumnDef="select">
                <th mat-header-cell *matHeaderCellDef>
                  <mat-checkbox (change)="$event ? masterToggle() : null"
                                [checked]="selection.hasValue() && isAllSelected()"
                                [indeterminate]="selection.hasValue() && !isAllSelected()">
                  </mat-checkbox>
                </th>
                <td mat-cell *matCellDef="let row">
                  <mat-checkbox (click)="$event.stopPropagation()"
                                (change)="$event ? selection.toggle(row) : null"
                                [checked]="selection.isSelected(row)">
                  </mat-checkbox>
                </td>
              </ng-container>


          <!-- Name Column -->
          <ng-container matColumnDef="plate">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> Plate </th>
              <td mat-cell *matCellDef="let element"> {{element.plate}} </td>
          </ng-container>

          <!-- Weight Column -->
          <ng-container matColumnDef="model">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> Model </th>
              <td mat-cell *matCellDef="let element"> {{element.model}} </td>
          </ng-container>

          <!-- Symbol Column -->
          <ng-container matColumnDef="mark">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> Mark </th>
              <td mat-cell *matCellDef="let element"> {{element.mark}} </td>
          </ng-container>


          <!-- Symbol Column -->
          <ng-container matColumnDef="year">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> Year </th>
              <td mat-cell *matCellDef="let element"> {{element.year}} </td>
          </ng-container>


               <!-- Symbol Column -->
               <ng-container matColumnDef="driver">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Driver </th>
                <td mat-cell *matCellDef="let element">


                  <span class="badge badge-pill badge-primary pilas" [ngStyle]="{'background-color':  getColorDriver(element.driverId)  }"> {{  getDriver(element.driverId) }}</span>

                </td>
            </ng-container>



          <!-- Symbol Column -->
          <ng-container matColumnDef="status">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> Status </th>
              <td mat-cell *matCellDef="let element">

                  <span class="badge badge-pill badge-primary pilas" [ngStyle]="{'background-color':  getColorStatus(element.status)  }"> {{  statusCar(element.status) }}</span>
              </td>
          </ng-container>



          <!-- Symbol Column -->
          <ng-container matColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> Actions </th>
              <th mat-header-cell *matHeaderCellDef> Symbol </th>
              <td mat-cell *matCellDef="let element">

                  <button class="btn btn-primary" (click)="openDialogEdit(element)"> <i class="fa fa-edit"></i></button>

                  <button class="btn btn-danger" (click)="unsignedCar(element)" style="margin-left:5px"> <i class="fa fa-truck"></i></button>

                  <button class="btn btn-danger" (click)="deleteCar(element)" style="margin-left:5px"> <i class="fa fa-remove"></i></button>

              </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>

      <mat-paginator [pageSizeOptions]="[10, 20, 30]" showFirstLastButtons></mat-paginator>
  </div>
</div>
